import * as React from "react";
import { UpdateControl, UpdateHeadered } from "../common/communication.base";
import { NclEmptyViewDialog } from "../common/components.ncl";
import { AcquireControl, K2ComponentState, withContext, WithContextPlacementProps } from "./k2hoc";

class _EmptyView extends React.PureComponent<WithContextPlacementProps, K2ComponentState<UpdateHeadered>> {
  static displayName = `K2EmptyView`;
  private control: NclEmptyViewDialog<any, any>;

  constructor(props: WithContextPlacementProps) {
    super(props);
    this.control = AcquireControl(this.props.controlUID, this.props.vrUID, (ctrl) => {
      return ctrl instanceof NclEmptyViewDialog;
    }) as NclEmptyViewDialog<any, any>;
    this.state = { data: this.control.init(this) as UpdateHeadered, vcxVersion: -1 };
  }

  componentWillUnmount() {
    this.control.willUnMount(true);
    this.control = null;
  }

  componentDidMount() {}

  updateState(state: UpdateControl) {
    this.setState(
      (prevState: K2ComponentState<UpdateHeadered>) => {
        return { data: state as UpdateHeadered };
      },
      () => {
        this.control.afterViewUpdated();
      }
    );
  }

  updateVCX(vcxVersion: number) {
    //
  }

  close(): Promise<void> {
    return Promise.resolve();
  }

  show(): Promise<void> {
    return Promise.resolve();
  }

  render(): JSX.Element {
    return null;
  }
}

export const K2EmptyView = withContext(_EmptyView);
